export interface IFileDeleteRequest {
    dno: number;
    filename: string;
    container_tag: string;
}